<script>
export default {
  name: 'EnableRemoteStatsCheckbox',
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    model(state) {
      this.$emit('input', state);
    },
  },
};
</script>

<template>
  <div class="checkbox">
    <label>
      <input type="checkbox" v-model="model">
      Подгружать статистику по API
    </label>
  </div>
</template>

<style scoped>
.checkbox {
  display: flex;
  align-items: center;
}
</style>
